import {
  Bottom,
  Container,
  Form,
  Item,
  InputGroup,
  Left,
  Right,
  Title,
  Top,
  Main,
  Follow,
  Social,
  UserTopic,
  Question,
  Answer,
  Icon,
  Msg,
} from "./Contact.Elements";
import "./contact.css";
import emailjs from "@emailjs/browser";
import { useEffect, useRef, useState } from "react";

const Contact = () => {
  const questionRef = useRef();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [showEmailSent, setShowEmailSent] = useState(false);
  const [isContactVisible, setIsContactVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting === true) {
        setIsContactVisible(true);
      } else {
        setIsContactVisible(false);
      }
    });
    observer.observe(questionRef.current);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    if (!name || !email || !message) {
      setErrorMessage("Fill all fields in contact form");
      return;
    }

    let templateParams = {
      name: name,
      email: email,
      message: message,
    };

    emailjs
      .send(
        "sumailblogs_service_7",
        "contactform_8hfveyz",
        templateParams,
        "gyqHDDydyQctyU7EZ"
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          console.log("Email Sent");
          setName("");
          setEmail("");
          setMessage("");
          setErrorMessage("");
          setShowEmailSent(true);
        },
        (err) => {
          console.log("FAILED...", err);
        }
      );
  };

  return (
    <Container id='contact'>
      <Top>
        <Title>CONTACT</Title>
      </Top>
      <Bottom>
        <Right>
          <Form onSubmit={sendEmail}>
            <InputGroup>
              <div className='group'>
                <input
                  type='text'
                  name='name'
                  id='name'
                  value={name}
                  autoComplete='off'
                  required
                  onChange={(e) => setName(e.target.value)}
                />
                <label htmlFor='name' className='label-name '>
                  <span className='content-name'>Name</span>
                </label>
              </div>
            </InputGroup>
            <InputGroup>
              <div className='group'>
                <input
                  type='email'
                  name='email'
                  id='email'
                  value={email}
                  autoComplete='off'
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
                <label htmlFor='email' className='label-name'>
                  <span className='content-name'>Email</span>
                </label>
              </div>
            </InputGroup>
            <InputGroup>
              <div className='group'>
                <input
                  type='text'
                  name='message'
                  id='message'
                  value={message}
                  autoComplete='off'
                  required
                  onChange={(e) => setMessage(e.target.value)}
                />
                <label htmlFor='message' className='label-name'>
                  <span className='content-name'>Message</span>
                </label>
              </div>
            </InputGroup>
            <InputGroup>
              <input
                type='submit'
                value={"Send Message"}
                className='send'
                onClick={sendEmail}
              />
            </InputGroup>
            {errorMessage && <Msg>{errorMessage}</Msg>}
            {showEmailSent && <Msg>Message Sent!</Msg>}
          </Form>
        </Right>
        <Left ref={questionRef}>
          <Main>
            <UserTopic>
              <Question
                ref={questionRef}
                className={isContactVisible === true ? "animateQuestion" : ""}
              >
                Need an article ?
              </Question>
              <Answer
                className={isContactVisible === true ? "animateAnswer" : ""}
              >
                We’d love to write an article or blog that you’re curious to
                read. Please fill the details in contact form with topic or
                technology on which you need an article.
              </Answer>
            </UserTopic>
            <Follow
              className={isContactVisible === true ? "animateFollow" : ""}
            >
              Talk to us !
            </Follow>
            <Social
              className={isContactVisible === true ? "animateSocial" : ""}
            >
              <Icon className='icon'>
                <svg
                  width='40'
                  height='40'
                  viewBox='0 0 50 50'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M39.5833 50H10.4167C4.66458 50 0 45.3354 0 39.5833V10.4167C0 4.66458 4.66458 0 10.4167 0H39.5833C45.3375 0 50 4.66458 50 10.4167V39.5833C50 45.3354 45.3375 50 39.5833 50ZM39.2896 36.8062C40.6021 36.8062 41.6667 35.7396 41.6667 34.4271V15.5729C41.6667 14.2604 40.6021 13.1937 39.2896 13.1937H10.7104C9.39792 13.1937 8.33333 14.2604 8.33333 15.5729V34.4271C8.33333 35.7396 9.39792 36.8062 10.7104 36.8062H39.2896ZM25 28.3521L12.025 19.35L11.9958 35.4167H37.9479V19.35L25 28.3521ZM37.3187 14.5833C33.6833 17.1146 25 23.2354 25 23.2354L12.6104 14.5833H37.3187Z'
                    fill='black'
                  />
                </svg>
              </Icon>
              <Icon className='icon'>
                <svg
                  width='40'
                  height='40'
                  viewBox='0 0 50 50'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M31.7354 11.4333C29.9792 11.3542 29.45 11.3375 25 11.3375C20.55 11.3375 20.0229 11.3542 18.2667 11.4333C13.7458 11.6396 11.6396 13.7812 11.4354 18.2646C11.3542 20.0229 11.3354 20.55 11.3354 25C11.3354 29.45 11.3542 29.9771 11.4333 31.7354C11.6396 36.2104 13.7375 38.3604 18.2646 38.5667C20.0208 38.6458 20.55 38.6646 25 38.6646C29.4521 38.6646 29.9792 38.6479 31.7354 38.5687C36.2562 38.3625 38.3604 36.2167 38.5667 31.7375C38.6458 29.9792 38.6625 29.4521 38.6625 25.0021C38.6625 20.5521 38.6458 20.025 38.5667 18.2687C38.3604 13.7833 36.2521 11.6396 31.7354 11.4333ZM25 33.5583C20.2729 33.5583 16.4417 29.7271 16.4417 25C16.4417 20.2729 20.275 16.4417 25 16.4417C29.725 16.4417 33.5583 20.2729 33.5583 25C33.5583 29.7271 29.7271 33.5583 25 33.5583ZM33.8979 18.1042C32.7937 18.1042 31.8979 17.2083 31.8979 16.1042C31.8979 15 32.7937 14.1042 33.8979 14.1042C35.0021 14.1042 35.8979 15 35.8979 16.1042C35.8979 17.2083 35.0021 18.1042 33.8979 18.1042ZM30.5562 25C30.5562 28.0687 28.0687 30.5562 25 30.5562C21.9312 30.5562 19.4438 28.0687 19.4438 25C19.4438 21.9312 21.9312 19.4438 25 19.4438C28.0687 19.4438 30.5562 21.9312 30.5562 25ZM39.5833 0H10.4167C4.66458 0 0 4.66458 0 10.4167V39.5833C0 45.3354 4.66458 50 10.4167 50H39.5833C45.3375 50 50 45.3354 50 39.5833V10.4167C50 4.66458 45.3375 0 39.5833 0V0ZM41.5667 31.8708C41.2917 37.9312 37.9187 41.2896 31.8729 41.5667C30.0937 41.6479 29.5271 41.6667 25 41.6667C20.4729 41.6667 19.9083 41.6479 18.1292 41.5667C12.0708 41.2896 8.7125 37.925 8.43333 31.8708C8.35208 30.0938 8.33333 29.5271 8.33333 25C8.33333 20.475 8.35208 19.9062 8.43333 18.1292C8.7125 12.0708 12.075 8.71042 18.1292 8.43542C19.9083 8.35208 20.4729 8.33333 25 8.33333C29.5271 8.33333 30.0937 8.35208 31.8729 8.43333C37.9312 8.71042 41.2958 12.0813 41.5667 18.1271C41.6479 19.9062 41.6667 20.475 41.6667 25C41.6667 29.5271 41.6479 30.0938 41.5667 31.8708Z'
                    fill='black'
                  />
                </svg>
              </Icon>
              <Icon className='icon'>
                <svg
                  width='40'
                  height='40'
                  viewBox='0 0 50 50'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M39.5833 0H10.4167C4.66458 0 0 4.66458 0 10.4167V39.5833C0 45.3354 4.66458 50 10.4167 50H39.5833C45.3375 50 50 45.3354 50 39.5833V10.4167C50 4.66458 45.3375 0 39.5833 0ZM16.6667 39.5833H10.4167V16.6667H16.6667V39.5833ZM13.5417 14.025C11.5292 14.025 9.89583 12.3792 9.89583 10.35C9.89583 8.32083 11.5292 6.675 13.5417 6.675C15.5542 6.675 17.1875 8.32083 17.1875 10.35C17.1875 12.3792 15.5562 14.025 13.5417 14.025ZM41.6667 39.5833H35.4167V27.9083C35.4167 20.8917 27.0833 21.4229 27.0833 27.9083V39.5833H20.8333V16.6667H27.0833V20.3438C29.9917 14.9563 41.6667 14.5583 41.6667 25.5021V39.5833Z'
                    fill='black'
                  />
                </svg>
              </Icon>
            </Social>
          </Main>
        </Left>
      </Bottom>
    </Container>
  );
};

export default Contact;
